/**
 * Объект целей авторизации через ВКонтакте
 * @typedef {object} AuthorizationVkGoals
 * @property {string} getCodeVk - Получить код ВКонтакте
 * @property {string} switchType - Подтвердить через звонок или СМС. Отказ от ВК
 * @property {string} limitErrorConfirm - Не получается подтвердить телефон через ВКонтакте. Подтвердить
 * @property {string} vkCodeInputSuccess - Ввёл код ВКонтакте
 * @property {string} switchTypeAfterProblemVk - Подтвердить через звонок или СМС. Проблема с кодом ВК, переход на звонок
 * @property {string} callCodeInputSuccess - Ввел последние цифры номера телефона входящего звонка. Успешный дозвон
 * @property {string} switchTypeAfterProblemCall - Подтвердить через СМС. Проблема с дозвоном, переход на СМС подтверждение
 */

/** @type {AuthorizationVkGoals} */
const AUTHORIZATION_VK_GOALS = {
  getCodeVk: 'authorizationVk__getCodeVk',
  switchType: 'authorizationVk__switchType',
  limitErrorConfirm: 'authorizationVk__limitErrorConfirm',
  vkCodeInputSuccess: 'authorizationVk__vkCodeInputSuccess',
  switchTypeAfterProblemVk: 'authorizationVk__switchTypeAfterProblemVk',
  callCodeInputSuccess: 'authorizationVk__callCodeInputSuccess',
  switchTypeAfterProblemCall: 'authorizationVk__switchTypeAfterProblemCall',
}

export default AUTHORIZATION_VK_GOALS
